import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { usePlatform } from "../platform/store";
import { PageRoot, RecordCard, SectionCard, SummaryGrid } from "./ui/PlatformPrimitives";

const WorkflowAutomation = () => {
  const { workflows } = usePlatform();

  return (
    // Disabled/preview state — glass cards rendered at lower contrast so the
    // page reads as "draft tooling" without losing the Liquid Glass aesthetic.
    <Box sx={{ opacity: 0.6 }}>
      <PageRoot>
        <SummaryGrid
          items={[
            ["Workflows", workflows.length],
            ["Active", workflows.filter((workflow) => workflow.status === "Active").length],
            ["Draft", workflows.filter((workflow) => workflow.status === "Draft").length],
          ]}
        />

        <Grid container spacing={2}>
          {workflows.map((workflow) => (
            <Grid key={workflow.id} size={{ xs: 12, md: 6 }}>
              <RecordCard
                title={workflow.name}
                subtitle={`${workflow.steps.length} steps`}
                status={workflow.status}
                footer={
                  <Typography color="text.secondary">
                    {workflow.steps.join(" -> ")}
                  </Typography>
                }
              />
            </Grid>
          ))}
        </Grid>

        <SectionCard eyebrow="Design" title="Workflow principles">
          <Typography color="text.secondary">
            Every workflow in the MVP is a gate over the same product graph: formula, documents, label drafts, PIF completeness, and review issues.
          </Typography>
        </SectionCard>
      </PageRoot>
    </Box>
  );
};

export default WorkflowAutomation;
